import React, { useEffect, useRef, useState } from "react";
import "./free-eye.css";
import { useDispatch, useSelector } from "react-redux";
import { getHeaderNews } from "../../../features/home/homeSlice";

const Free_eye = () => {
  const dispatch = useDispatch();
  const headerNews = useSelector((state) => state.home.header_news);

  const trackRef = useRef(null);
  const [duration, setDuration] = useState(20);

  useEffect(() => {
    dispatch(getHeaderNews());
  }, [dispatch]);

  // ✅ Dynamic repeat count
  const minItemsNeeded = 5;

  const repeatCount = headerNews?.length
    ? Math.ceil(minItemsNeeded / headerNews.length)
    : 0;

  const loopNews =
    headerNews && headerNews.length > 0
      ? Array(repeatCount).fill(headerNews).flat()
      : [];

  // ✅ SAME SPEED LOGIC
  useEffect(() => {
    if (trackRef.current) {
      const totalWidth = trackRef.current.scrollWidth;

      const speed = 200; // px per second (change if needed)

      const calculatedDuration = totalWidth / speed;

      setDuration(calculatedDuration);
    }
  }, [loopNews]);

  return (
    <section className="Free_eye_sec">
      <div className="ticker">
        <div
          className="ticker-track"
          ref={trackRef}
          style={{ animationDuration: `${duration}s` }}
        >
          {loopNews.map((val, i) => (
            <p className="mesg" key={i}>
              {val?.name}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Free_eye;